/**
  * set equal height to child elements of all slides
 *
 */
function equalizePackages() {
  const element = document.querySelectorAll('.highlight-grid, .post-grid');

  element.forEach(function(item) {
    const images = item.querySelectorAll(".image, .featured-image");
    const postTags = item.querySelectorAll(".post-tags");
    //const archiveThumbnails = item.querySelectorAll(".post-thumbnail");
    //const conditions = element.querySelectorAll(".additional-excerpt");

    const elementLists = [images, postTags];

    elementLists.forEach((list) => {
      resetHeight(list);
      const maxHeight = getMaxHeight(list);
      setHeight(list, maxHeight);
    });
  });
}

/**
 * removes height property of elements' styles
 * @param {NodeList} elementList
 */
function resetHeight(elementList) {
  for (const element of elementList) {
    element.style.removeProperty("height");
  }
}

/**
 * get greatest height of given elements
 * @param {NodeList} elementList
 * @returns {Number}
 */
function getMaxHeight(elementList) {
  let maxHeight = 0;
  for (const element of elementList) {
    const height = element.clientHeight;
    maxHeight = Math.max(height, maxHeight);
  }
  return maxHeight;
}

/**
 * set height of given elements
 * @param {NodeList} elementList
 * @param {Number} height
 * @returns
 */
function setHeight(elementList, height) {
  if (!Number.isInteger(height)) return;

  for (const element of elementList) {
    element.style.height = `${height}px`;
  }
}
